module.exports = __webpack_public_path__ + "static/media/shoeCare.49288fc3.webp";